var exports = {
  "J": "ProfileCardContent.module__contentSection___dHg0TW",
  "s": "ProfileCardContent.module__contentSectionWebhook___dHg0TW",
};

module.exports = exports;
